import React, { useEffect, useState } from 'react'
import NavigationBar from '../../../components/Navigationbar/Navigationbar'
import { Box, Input, Link, Table } from '@mui/joy'
import Headline from '../../../components/headline/Headline';
import SearchIcon from '@mui/icons-material/Search';
import { post, Token } from '../../../Script/Session';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash/debounce';
function Betriebsliste() {
    const [data, setdata] = useState();
    const [wit, setWit] = useState("90.5%");
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const navigate = useNavigate();
      useEffect(() => {
        const handler = debounce(() => {
          setDebouncedSearchTerm(searchTerm);
        }, 300);
        handler();
        return () => handler.cancel();
      }, [searchTerm]);
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "get_list";
        let response = post(body, "/betriebe");
        if (response == "LOGOUT") {
            navigate("/");
        }
        setdata(JSON.parse(response));
    })
    return (
        <>
            <Box
                sx={{
                    width: wit,
                    position: "fixed",
                    top: 0,
                    right: 0,
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    bgcolor: "background.body",
                    borderLeft: "1px solid",
                    borderColor: "divider",
                    overflowY: "auto",
                }}
            >
                <Headline title={"Betriebsliste"} />
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 2, mt: 4 }}>
                    <Input
                        placeholder="Suche..."
                        startDecorator={<SearchIcon />}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        sx={{ width: 500 }}
                    />
                </Box>
                <Table sx={{ width: "99%" }}>
                    <thead>
                        <tr>
                            <th>Betrieb</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data && data.result.slice().filter(item => item.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())).map((item) => {
                                return (
                                    <tr key={item.id}>
                                        <td><Link href={window.location.origin + "/view-betrieb/" + item.id}>{item.name}</Link></td>
                                    </tr>)
                            })
                        }
                    </tbody>
                </Table>
            </Box>
            <NavigationBar state="profile" back={true} />
        </>
    )
}

export default Betriebsliste
